import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

import { AlertService } from '../../services/alert.service';
import { CommunityService } from '../../services/community.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'community-comment-card',
    templateUrl: './community-comment-card.component.html',
    styleUrls: ['./community-comment-card.component.scss']
})
export class CommunityCommentCardComponent implements OnInit, OnDestroy {

    @Input()
    comment: any;

    @Output('updateUser')
    updateUserEventEmitter = new EventEmitter<any>();

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private communityService: CommunityService
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    updateUserBanned(banned: boolean) {
        console.log('CommunityCommentCardComponent.updateUserBanned.user.id', this.comment.user.id);
        this.progressIndicatorService.progress = true;
        this.communityService.updateUserBanned(this.comment.user.id, banned).subscribe({
            next: (value: any) => {
                console.log('CommunityCommentCardComponent.updateUserBanned.communityService.updateUserBanned.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.comment.user.banned = banned;
                this.updateUserEventEmitter.emit(this.comment.user);
            },
            error: (error: any) => {
                console.log('CommunityCommentCardComponent.updateUserBanned.communityService.updateUserBanned.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    commentDeletedControlChange(deleted: string) {
        console.log('CommunityCommentCardComponent.commentDeletedControlChange.deleted', deleted);
        this.progressIndicatorService.progress = true;
        this.communityService.updateCommentDeleted(this.comment.id, deleted).subscribe({
            next: (value: any) => {
                console.log('CommunityCommentCardComponent.commentDeletedControlChange.communityService.updateCommentDeleted.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.comment.deleted = deleted == 'true' ? true : deleted == 'false' ? false : null;
            },
            error: (error: any) => {
                console.log('CommunityCommentCardComponent.commentDeletedControlChange.communityService.updateCommentDeleted.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    commentInappropriateControlChange(inappropriate: string) {
        console.log('CommunityCommentCardComponent.commentInappropriateControlChange.inappropriate', inappropriate);
        this.progressIndicatorService.progress = true;
        this.communityService.updateCommentInappropriate(this.comment.id, inappropriate).subscribe({
            next: (value: any) => {
                console.log('CommunityCommentCardComponent.commentInappropriateControlChange.communityService.updateCommentInappropriate.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.comment.inappropriate = inappropriate == 'true' ? true : inappropriate == 'false' ? false : null;
            },
            error: (error: any) => {
                console.log('CommunityCommentCardComponent.commentInappropriateControlChange.communityService.updateCommentInappropriate.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
